<template>
  <a-modal
    title="新建企业"
    style="top: 20px;"
    :width="1400"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
  >
    <div class="table-page-search-wrapper">
      <a-form :form="form" layout="inline">
        <label style="color: #2D93F2;">基本信息</label>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入企业名称 :</label>-->
              <!--<span style="color:red;position: absolute;left: 32px;">*</span>-->
              <a-input v-decorator="['enterpriseName', { rules: [{ required: true, message: '请输入企业名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业简称">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入企业简称 :</label>-->
              <!--<span style="color:red;position: absolute;left: 32px;">*</span>-->
              <a-input
                autocomplete="off"
                v-decorator="['enterpriseSysName', { rules: [{ required: true, message: '请输入企业简称' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册人" style="margin-left: 14px">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入注册人 :</label>-->
              <!--<span style="color:red;position: absolute;left: 44px;">*</span>-->
              <a-input
                autocomplete="off"
                v-decorator="['register', { rules: [{ required: true, message: '请输入注册人' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式" style="margin-left: 28px">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入联系方式 :</label>-->
              <!--<span style="color:red;position: absolute;left: 32px;">*</span>-->
              <a-input
                autocomplete="off"
                v-decorator="['registerPhone', { rules: [{ required: true, message: '请输入联系方式' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业账号">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入企业账号 :</label>-->
              <!--<span style="color:red;position: absolute;left: 32px;">*</span>-->
              <a-input v-decorator="['loginName', { rules: [{ required: true, message: '请输入企业账号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="账号姓名">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入账号姓名 :</label>-->
              <!--<span style="color:red;position: absolute;left: 32px;">*</span>-->
              <a-input v-decorator="['userName', { rules: [{ required: true, message: '请输入姓名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="手机号" style="margin-left: 14px">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入手机号 :</label>-->
              <!--<span style="color:red;position: absolute;left: 44px;">*</span>-->
              <a-input
                v-decorator="['phone', { rules: [{ validator: this.isPhone, required: true }] }]"
                autocomplete="off"
              />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="密码" style="margin-left: 56px">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入密码 :</label>-->
              <!--<span style="color:red;position: absolute;left: 58px;">*</span>-->
              <a-input
                autocomplete="off"
                v-decorator="['password', { rules: [{ validator: this.isPwd, required: true }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业协会" v-if="userType == '00'">
              <a-select v-decorator="['enterpriseType', { rules: [{ required: true, message: '请选择企业协会' }] }]">
                <a-select-option value="0">否</a-select-option>
                <a-select-option value="2">是</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业类型">
              <a-select v-decorator="['types', { rules: [{ required: true, message: '请选择企业类型' }] }]">
                <a-select-option :value="0">锁企</a-select-option>
                <a-select-option :value="1">电信公司</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="18">
            <a-row type="flex" justify="space-between" align="bottom">
              <label style="margin-right: -20px;color: #2D93F2;">安装类别</label>
              <a-checkbox-group
                v-model="installTypes"
                v-decorator="['installTypes']"
                @change="onChange"
                style="width: calc(100% - 100px)"
              >
                <a-checkbox v-for="type in installTypeMap" :value="type.value">
                  {{ type.label }}
                </a-checkbox>
              </a-checkbox-group>
            </a-row>
          </a-col>
          <a-col :span="6">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="默认安装类别" style="width: 100%">
              <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">请输入默认安装类别 :</label>-->
              <!--<span style="color:red;position: absolute;left: 8px;">*</span>-->
              <a-select
                v-decorator="['defaultInstallType', { rules: [{ required: true, message: '请输入默认安装类别' }] }]"
              >
                <a-select-option v-for="item in installTabs" :key="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-tabs @change="callback" type="card">
          <a-tab-pane v-for="item in installTabs" :tab="item.label" :key="item.value">
            <a-row style="margin-top: 15px;" :gutter="16">
              <a-col :span="6">
                <a-form-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 20px">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">负责人 :</label>-->
                  <a-input v-decorator="['principalName$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="负责人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">负责人电话 :</label>-->
                  <a-input v-decorator="['principalPhone$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="技术人员" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 14px">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">技术人员 :</label>-->
                  <a-input v-decorator="['techniqueName$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="技术电话" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 42px">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">技术电话 :</label>-->
                  <a-input v-decorator="['techniquePhone$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="技术人员2" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">技术人员2 :</label>-->
                  <a-input v-decorator="['techniqueName2$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="技术2电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业负责人 :</label>-->
                  <a-input v-decorator="['techniquePhone2$' + item.value]" />
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="客服负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业负责人 :</label>-->
                  <a-input v-decorator="['customerServiceName$' + item.value]" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="客服负责人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业负责人 :</label>-->
                  <a-input v-decorator="['customerServicePhone$' + item.value]" />
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
        <div style="margin-top: 40px;">
          <label style="color: #2D93F2;">企业档案</label>
          <a-row style="margin-top: 10px;margin-left: 2%" :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 28px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业负责人 :</label>-->
                <a-input v-decorator="['enterprisePrincipal']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业负责人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业负责人电话 :</label>-->
                <a-input v-decorator="['enterprisePrincipalPhone']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="财务负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 28px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">财务负责人 :</label>-->
                <a-input v-decorator="['financePrincipal']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="财务负责人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">财务负责人电话 :</label>-->
                <a-input v-decorator="['financePrincipalPhone']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业开票" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业开票 :</label>-->
                <a-select
                  :allowClear="true"
                  :options="enterpriseInvoiceMap"
                  v-decorator="['enterpriseInvoice']"
                ></a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="发票抬头" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">发票抬头 :</label>-->
                <a-input v-decorator="['invoiceTitle']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="发票类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">发票类型 :</label>-->
                <a-select v-decorator="['invoiceType']" :allowClear="true">
                  {{ invoiceTypeMap }}
                  <a-select-option v-for="item in invoiceTypeMap" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="税号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 69px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">税号 :</label>-->
                <a-input v-decorator="['enterpriseTaxNo']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 54px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">开户行 :</label>-->
                <!--<a-input  v-decorator="['enterpriseCardorg']"/>-->
                <a-select
                  showSearch
                  optionFilterProp="children"
                  v-decorator="['enterpriseCardorg']"
                  :filterOption="filterOption"
                  allowClear="true"
                >
                  <a-select-option v-for="item of bankName" :title="item.name" :key="item.id">{{
                    item.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="详细地址" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px;">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">详细地址 :</label>-->
                <a-input v-decorator="['enterpriseAddress']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="付款方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px;">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">付款方式 :</label>-->
                <a-select v-decorator="['enterprisePayType']" :allowClear="true">
                  <a-select-option v-for="item in payTypeMap" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="银行卡账号" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 28px;">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">银行卡账号 :</label>-->
                <a-input v-decorator="['enterpriseCardNumber']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 68px">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">电话 :</label>-->
                <a-input v-decorator="['enterpriseMobile']" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="结算周期" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px;">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">结算周期 :</label>-->
                <a-select v-decorator="['enterpriseSettlementType']" @change="changeSettlementType" :allowClear="true">
                  <a-select-option v-for="item in settleCycleMap" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <label style="width:116px;text-align: right;padding: 0 8px 0 0;margin-left: 52px">省市区 :</label>
                <a-select
                  style="width: 120px;margin-right: 20px"
                  v-decorator="['province']"
                  @change="changeProvince"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in provinceMap" :key="type.provinceCode">
                    {{ type.provinceName }}
                  </a-select-option>
                </a-select>
                <a-select
                  v-decorator="['city']"
                  style="width: 120px;margin-right: 20px"
                  @change="changeCity"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in cityMap" :key="type.cityCode">{{ type.cityName }}</a-select-option>
                </a-select>
                <a-select v-decorator="['area']" style="width: 120px;margin-right: 20px" :allowClear="true">
                  <a-select-option v-for="type in areaMap" :key="type.areaCode">{{ type.areaName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业星级" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 41px;">
                <!--<label style="width:180px;text-align: right;padding: 0 8px 0 0">企业星级 :</label>-->
                <a-select v-decorator="['enterpriseStar']" default-value="3" :allowClear="true">
                  <a-select-option v-for="item in enterpriseLevelMap" :key="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <!-- 旧件寄回地址 -->
        <div class="mtb-40">
          <label style="color: #2D93F2;">旧件寄回地址</label>
          <div class="flex">
            <label style="color: #2D93F2;"></label>
            <a-button
              :disabled="sendRequestList.length == 5"
              @click="sendRequestAdd"
            >添加寄件要求</a-button
            >
          </div>
          <div v-for="(item, index) in sendRequestList" :key="index">
            <a-row style="margin-top: 10px" :gutter="16">
              <a-col :span="6">
                <a-form-item label="寄件要求" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model.trim="item.requirement" :maxlength="20" />
                </a-form-item>
              </a-col>
              <a-col :span="6">

                <a-popconfirm
                  placement="top"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="sendRequestDel(index)"
                >
                  <template slot="title">
                    <p>删除后该寄件要求不可使用！</p>
                  </template>
                  <a-tag color="cyan">
                    删除
                  </a-tag>
                </a-popconfirm>
                <!-- <a-button size="small" @click="sendBackOldHandleDel(index)">删除</a-button> -->

              </a-col>
            </a-row>
          </div>
          <div class="flex mt-10">
            <label style="color: #2D93F2;"></label>
            <a-button
              :disabled="sendBackOldPiecesList.length == 5"
              @click="sendBackOldPiecesAdd"
            >添加寄回地址</a-button
            >
          </div>
          <div v-for="(item, index) in sendBackOldPiecesList" :key="index">
            <a-row style="margin-top: 10px" :gutter="16">
              <a-col :span="6">
                <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input v-model.trim="item.contact" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="联系方式"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"

                >
                  <a-input v-model.trim="item.phoneNumber" @blur="changePhone" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item
                  label="地址"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  :prop="'sendBackOldPiecesList.' + index + '.address'"
                >
                  <a-input v-model.trim="item.address" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <div class="flex">
                  <!-- <span>是否默认</span> -->
                  <!-- :defaultChecked="index == 0 ? true : false" -->
                  <div>
                    <span class="mr-10">是否默认:</span>
                    <a-switch
                      :defaultChecked="index == 0 ? true : false"
                      :checked="item.defaultStatus == 0 ? true : false"
                      @click="switchChange(index)"
                    />
                  </div>

                  <a-popconfirm
                    placement="top"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="sendBackOldHandleDel(index)"
                  >
                    <template slot="title">
                      <p>删除后该地址则不可使用！</p>
                    </template>
                    <a-tag color="cyan">
                      删除
                    </a-tag>
                  </a-popconfirm>
                  <!-- <a-button size="small" @click="sendBackOldHandleDel(index)">删除</a-button> -->
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import {
  selectFindAll,
  addEnterprise,
  getselectAllProvince,
  getselectCityName,
  getselectAreaName
} from '@/api/enterprise/enterprise'
import pick from 'lodash.pick'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import ARow from 'ant-design-vue/es/grid/Row'
import store from '@/store'
import { checkPhoneNumber } from '@/utils/common'
export default {
  name: 'EnterpriseRegistration',
  components: { ARow },
  data () {
    return {
      bankName: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],
      value: 'a',
      form: this.$form.createForm(this),
      confirmLoading: false,
      visible: false,
      param: {},
      installTypeMap: [],
      invoiceTypeMap: [],
      installTypes: [],
      installTabs: [],
      provinceMap: [],
      cityMap: [],
      areaMap: [],
      enterpriseLevelMap: [],
      settleCycleMap: [],
      payTypeMap: [],
      enterpriseInvoiceMap: [],
      userType: '',
      isDefaultAddress: false, // 是否为默认地址
      // 旧件寄回地址联系方式校验
      phoneFlag: true,
      sendBackOldPiecesList: [{
        contact: '',
        phoneNumber: '',
        address: '',
        defaultStatus: '0'
      }], // 旧件寄回地址列表
      // 寄回要求数据
      sendRequestList: [{ requirement: '' }],
      indexSendBackOld: 0, // 下标-旧件寄回地址列表
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      // 表单校验
      rules: {
        telephone: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          },
          {
            validator: checkPhoneNumber,
            trigger: 'blur'
          }
        ],
        contact: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ]

      }
    }
  },
  async created () {
    this.userType = this.$store.getters.userType
    console.log('userType', this.userType)
    // 省
    await getselectAllProvince().then(res => {
      if (res.code === 0) {
        this.provinceMap = res.rows
      }
    })
  },
  methods: {
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 密码正则表达式
    isPwd (rule, value, callback) {
      const pwdRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/]).{8,64}$/
      if (value && !pwdRegex.test(value)) {
        callback(new Error('请输入8位以上密码，必须包含数字、字母、英文特殊字符'))
      } else if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    },
    // 旧件寄回地址联系方式校验
    changePhone (e) {
      const pwdRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if (!pwdRegex.test(e.target.value)) {
        this.$message.error('请输入11位联系方式')
        this.phoneFlag = false
      } else {
        this.phoneFlag = true
      }
    },
    // 手机号正则表达式
    isPhone (rule, value, callback) {
      console.log(rule, value, callback)
      const pwdRegex = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入11位联系方式'))
      } else {
        callback()
      }
    },
    add (parentId) {
      console.log('parentId', parentId)
      this.installTypeMap = []
      this.payTypeMap = []
      this.enterpriseInvoiceMap = []
      this.invoiceTypeMap = []
      this.enterpriseLevelMap = []
      this.settleCycleMap = []
      this.sendBackOldPiecesList = [{
        contact: '',
        phoneNumber: '',
        address: '',
        defaultStatus: '0'
      }]
      this.form.resetFields()
      selectFindAll({
        dictTypes: 'pay_type,settle_cycle,enterprise_level,install_type,invoice_type,enterprise_invoice'
      }).then(res => {
        // console.log(res)
        // 企业开票
        this.enterpriseInvoiceArr = res.enterprise_invoice
        this.enterpriseInvoiceArr.forEach((value, key) => {
          this.enterpriseInvoiceMap.push({ value: value.dictValue, label: value.dictLabel })
        })
        // 付款方式
        this.payTypeArr = res.pay_type
        this.payTypeArr.forEach((value, key) => {
          this.payTypeMap.push({ value: value.dictValue, label: value.dictLabel })
        })
        // 结算周期
        this.settleCycleArr = res.settle_cycle
        this.settleCycleArr.forEach((value, key) => {
          this.settleCycleMap.push({ value: value.dictValue, label: value.dictLabel })
        })
        // 企业星级
        this.enterpriseLevelArr = res.enterprise_level
        this.enterpriseLevelArr.forEach((value, key) => {
          this.enterpriseLevelMap.push({ value: value.dictValue, label: value.dictLabel })
        })
        // 安装类型
        this.installTypeArr = res.install_type
        this.installTypeArr.forEach((value, key) => {
          this.installTypeMap.push({ value: value.dictValue, label: value.dictLabel })
        })

        // 发票类型
        this.invoiceTypeArr = res.invoice_type
        this.invoiceTypeArr.forEach((value, key) => {
          this.invoiceTypeMap.push({ value: value.dictValue, label: value.dictLabel })
        })
      })
      this.edit({})
    },
    edit (record) {
      this.mdl = Object.assign(record)
      // console.log(JSON.stringify(this.mdl))
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'enterpriseName',
            'enterpriseSysName',
            'enterpriseAddress',
            'enterpriseMobile',
            'enterpriseType',
            'types',
            'enterprisePrincipal',
            'enterpriseCardNumber',
            'enterpriseCardorg',
            'financePrincipal',
            'enterpriseInvoice',
            'invoiceType',
            'invoiceTitle'
          )
        )
      })
      this.$nextTick(() => {
        this.form.setFieldsValue({
          enterpriseStar: '3'
        })
        this.form.setFieldsValue({
          enterprisePayType: '2'
        })
        this.form.setFieldsValue({
          enterpriseSettlementType: '2'
        })
      })
    },
    onChange (value) {
      // console.log(value,'安装类别')
      this.installTabs = []
      for (var i = 0; i < this.installTypeMap.length; i++) {
        this.install = this.installTypeMap[i]
        for (var j = 0; j < this.installTypes.length; j++) {
          this.installValue = this.installTypes[j]
          if (this.installValue === this.install.value) {
            this.installTabs.push({ value: this.install.value, label: this.install.label })
          }
        }
      }
      // console.log(JSON.stringify(this.installTabs))
    },
    changeProvince (e) {
      // 市
      this.cityMap = []
      this.areaMap = []
      this.form.setFieldsValue({
        city: undefined
      })
      this.form.setFieldsValue({
        area: undefined
      })
      this.province = { provinceCode: e }
      getselectCityName(this.province).then(res => {
        if (res.code === 0) {
          this.cityMap = res.rows
        }
      })
    },
    changeCity (e) {
      // 区
      this.areaMap = []
      this.form.setFieldsValue({
        area: ''
      })
      this.city = { cityCode: e }
      getselectAreaName(this.city).then(res => {
        if (res.code === 0) {
          this.areaMap = res.rows
        }
      })
    },
    onChangebtn (e) {
      // console.log(`checked = ${e.target.value}`)
    },
    callback (key) {
      // console.log(key)
    },
    // 旧件寄回-添加行
    sendBackOldPiecesAdd () {
      if (this.sendBackOldPiecesList.length == 0) {
        this.sendBackOldPiecesList.push({
          contact: '',
          phoneNumber: '',
          address: '',
          defaultStatus: '0'
        })
      } else {
        this.sendBackOldPiecesList.push({
          contact: '',
          phoneNumber: '',
          address: '',
          defaultStatus: '1'
        })
      }
      this.indexSendBackOld++
    },
    // 旧件寄回要求-添加行
    sendRequestAdd () {
      this.sendRequestList.push({
        requirement: ''
      })
    },
    // 旧件寄回要求-删除行
    sendRequestDel (index) {
      this.sendRequestList.splice(index, 1)
    },
    // 旧件寄回-删除行
    sendBackOldHandleDel (index) {
      if (this.sendBackOldPiecesList[index].defaultStatus == 0) {
        this.sendBackOldPiecesList.splice(index, 1)
        if (this.sendBackOldPiecesList[0]) {
          this.sendBackOldPiecesList[0].defaultStatus = 0
        }
      } else {
        this.sendBackOldPiecesList.splice(index, 1)
      }
    },
    // 开关-变换
    switchChange (index) {
      const indexFind = this.sendBackOldPiecesList.findIndex(item => {
        return item.defaultStatus == 0
      })
      const defaultStatus = this.sendBackOldPiecesList[index].defaultStatus
      this.sendBackOldPiecesList[index].defaultStatus = defaultStatus == 1 ? 0 : 1
      this.sendBackOldPiecesList[indexFind].defaultStatus = index == indexFind ? 0 : 1
    },
    handleSubmit () {
      this.form.validateFields((err, values) => {
        console.log('Received values of form: ', values)
        if (!err) {
          const objArray = {}
          // console.log(this.installTypes)
          for (const installType of this.installTypes) {
            // console.log(installType)
            const obj = {}
            obj['insatllationCode'] = installType
            for (const val in values) {
              const index = val.indexOf('$' + installType)
              if (index !== -1) {
                const tempValName = val.substr(0, index)
                obj[tempValName] = values[val]
                delete values[val]
              }
            }
            objArray[installType] = obj
          }
          this.confirmLoading = true
          values.installTypes = this.installTypes
          values.contacts = this.sendBackOldPiecesList
          values.enterpriseSendBack = this.sendRequestList.filter(e => e.requirement != '')

          values['installationUsers'] = objArray
          let flag = true
          this.sendBackOldPiecesList.map(item => {
            if ((item.contact == '' && item.phoneNumber == '' && item.address == '') || (item.contact && item.phoneNumber && item.address)) {

            } else {
              flag = false
              this.$message.error('旧件寄回地址填写不完整!')
              this.confirmLoading = false
            }
          })
          if (flag) {
            if (this.phoneFlag) {
              addEnterprise(values)
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success('保存成功')
                    this.$emit('ok')
                    this.visible = false
                  } else {
                    this.$message.error(res.msg)
                  }
                })
                .catch(() => {
                  this.$message.error('系统错误，请稍后再试')
                })
                .finally(() => {
                  this.confirmLoading = false
                })
            } else {
              this.confirmLoading = false
              this.$message.error('请输入11位联系方式')
            }
          }
        } else {
          console.log('112123123')
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
/*/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {*/
/*line-height: 32px;*/
/*padding-right: 8px;*/
/*width: 120px;*/
/*}*/
/*/deep/  .ant-form-item-children{*/
/*position: relative;*/
/*display: flex;*/
/*margin-bottom: 24px;*/
/*margin-right: 0;*/
/*}*/
</style>
